import LogoImage from "../shared/logo_image";
import Link from "next/link";
import { useState } from "react";
import chunk from "lodash/chunk";
import useTranslation from "next-translate/useTranslation";

const MAX_GROUPS = 8;

const IconsList = (props) => {
  const [showOthers, setShowOthers] = useState(false);
  const { t } = useTranslation("common");

  return (
    <>
      <div className="d-flex mt-2">
        {props.groups.slice(0, MAX_GROUPS).map((group) => (
          <Link key={group.token} href={`/groups/${group.token}`}>
            <a className={`col-auto ${props.marginClass}`}>
              <LogoImage width={props.width} height={props.height} src={group.logo_thumb} name={group.name} />
            </a>
          </Link>
        ))}
        {props.children}
      </div>

      {props.groups.length > MAX_GROUPS && !showOthers && (
        <a className="small" onClick={() => setShowOthers(!showOthers)}>{`+ ${props.groups.length - MAX_GROUPS} ${t(
          "more_persons"
        ).toLowerCase()}`}</a>
      )}

      {showOthers &&
        chunk(props.groups.slice(MAX_GROUPS, props.groups.length), MAX_GROUPS).map((chunk, idx) => (
          <div className="d-flex mt-2" key={`chunk${idx}`}>
            {chunk.map((group) => (
              <Link key={group.token} href={`/groups/${group.token}`}>
                <a className={`col-auto ${props.marginClass}`}>
                  <LogoImage width={props.width} height={props.height} src={group.logo_thumb} name={group.name} />
                </a>
              </Link>
            ))}
          </div>
        ))}
    </>
  );
};

export default IconsList;

IconsList.defaultProps = {
  marginClass: "me-2",
  width: 32,
  height: 32,
};
